<template>
  <div>
    <v-row v-if="getVersion == 'v2'">
      <v-col cols="6" v-if="isLTMData">
        <v-card class max-width="100%" height="100%">
          <v-card-text class="mb-4">
            <h2 class="text-center mb-4">Clients Last Twelve Months</h2>
            <DashboardLastTwelveMonth
              :ltm_data="get_last_twelve_month.total_clients || {data:[]}"
              :ltm_label="ltmLabel"
              color="#2E93fA"
            ></DashboardLastTwelveMonth>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" v-if="isLTMData">
        <v-card class max-width="100%" height="100%">
          <v-card-text class="mb-4">
            <h2 class="text-center mb-4">HRs Last Twelve Months</h2>
            <DashboardLastTwelveMonth
              :ltm_data="get_last_twelve_month.total_hr || {data:[]}"
              :ltm_label="ltmLabel"
              color="#66DA26"
            ></DashboardLastTwelveMonth>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="getVersion == 'v2'">
      <v-col cols="6" v-if="isLTMData">
        <v-card class max-width="100%" height="100%">
          <v-card-text class="mb-4">
            <h2 class="text-center mb-4">Policies Last Twelve Months</h2>
            <DashboardLastTwelveMonth
              :ltm_data="get_last_twelve_month.total_policies || {data:[]}"
              :ltm_label="ltmLabel"
              color="#546E7A"
            ></DashboardLastTwelveMonth>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" v-if="isLTMData">
        <v-card class max-width="100%" height="100%">
          <v-card-text class="mb-4">
            <h2 class="text-center mb-4">Members Last Twelve Months</h2>
            <DashboardLastTwelveMonth
              :ltm_data="get_last_twelve_month.total_members || {data:[]}"
              :ltm_label="ltmLabel"
              color="#E91E63"
            ></DashboardLastTwelveMonth>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="getVersion == 'v2'">
      <v-col cols="6" v-if="isLTMData">
        <v-card class max-width="100%" height="100%">
          <v-card-text class="mb-4">
            <h2 class="text-center mb-4">Member Additions Last Twelve Months</h2>
            <DashboardLastTwelveMonth
              :ltm_data="get_last_twelve_month.total_additions || {data:[]}"
              :ltm_label="ltmLabel"
              color="#546E7A"
            ></DashboardLastTwelveMonth>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" v-if="isLTMData">
        <v-card class max-width="100%" height="100%">
          <v-card-text class="mb-4">
            <h2 class="text-center mb-4">Member Terminations Last Twelve Months</h2>
            <DashboardLastTwelveMonth
              :ltm_data="get_last_twelve_month.total_terminations || {data:[]}"
              :ltm_label="ltmLabel"
              color="#E91E63"
            ></DashboardLastTwelveMonth>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class max-width="auto" height="100%">
          <v-card-text>
            <h2 class="text-center mb-4">Total Company by Regions</h2>
            <DashboardGraphDialog
              class="mb-5"
              @childFilterGraph="filterTotalCompany"
              @childResetFilter="resetFilterTotalCompany"
              :dateLabel="filterTotalCompanyDate"
              :data="get_filter_total_company"
            ></DashboardGraphDialog>
            <RegionsBarChart :chartData="regionsData"></RegionsBarChart>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class max-width="auto" height="100%">
          <v-card-text class="mb-4">
            <h2 class="text-center mb-4">Company Access Times</h2>
            <DashboardGraphDialog
              class="mb-5"
              @childFilterGraph="filterCompAccess"
              @childResetFilter="resetFilterCompAccess"
              :dateLabel="filterDate"
              :data="get_filter_comp_access"
              myFilters="with_filter"
            ></DashboardGraphDialog>
            <DashboardGraph :comp-data="get_comp_access" :max=get_filter_comp_access.maxItem></DashboardGraph>
            <DashboardGraphFullScreen :comp-data="get_comp_access" :max=get_filter_comp_access.maxItem></DashboardGraphFullScreen>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card class max-width="auto">
          <v-card-text>
            <h2 class="text-center mb-4">Summary</h2>
            <DashboardSummary :comp-data="get_comp_access"></DashboardSummary>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DashboardLastTwelveMonth from "../components/dashboard/DashboardLastTwelveMonth";
import DashboardGraph from "../components/dashboard/DashboardGraph";
import DashboardGraphFullScreen from "../components/dashboard/DashboardGraphFullScreen";
import DashboardGraphDialog from "../components/dashboard/DashboardGraphDialog";
import DashboardSummary from "../components/dashboard/DashboardSummary";
import RegionsBarChart from "@/components/dashboard/DashboardTotalCompany";
import {
  parse,
  lastDayOfMonth,
  getDate,
  compareAsc
} from "date-fns";

export default {
  name: "Dashboard",
  components: {
    DashboardLastTwelveMonth,
    DashboardGraph,
    DashboardGraphFullScreen,
    DashboardSummary,
    DashboardGraphDialog,
    RegionsBarChart
  },
  data() {
    return {
      filterCompanyByRegions: {
        dates: [],
      },
      filterDate: [],
      filterTotalCompanyDate: [],
      ltmLabel: [],
    };
  },
  methods: {
    goto(url) {
      this.$router.push(url);
    },
    resetFilterCompAccess() {
      this.filterDate = [];
      this.$store.dispatch("Dashboard/RESET_FILTER_COMPANY_ACCESS");
      this.$store.dispatch("Dashboard/GET_COMPANY_ACCESS", {
        filter: 0
      });
    },
    getDatePeriod(data) {
      let start_date;
      let end_date;
      if (data.length === 2) {
        let isMore = compareAsc(
          parse(data[0] + "-01", "yyyy-MM-dd", new Date()),
          parse(data[1] + "-01", "yyyy-MM-dd", new Date())
        );
        if (isMore === 1) {
          start_date = data[1] + "-01";
          end_date =
            data[0] +
            "-" +
            getDate(
              lastDayOfMonth(parse(data[0] + "-01", "yyyy-MM-dd", new Date()))
            );
        } else {
          start_date = data[0] + "-01";
          end_date =
            data[1] +
            "-" +
            getDate(
              lastDayOfMonth(parse(data[1] + "-01", "yyyy-MM-dd", new Date()))
            );
        }
      } else {
        start_date = data[0] + "-01";
        end_date =
          data[0] +
          "-" +
          getDate(
            lastDayOfMonth(parse(data[0] + "-01", "yyyy-MM-dd", new Date()))
          );
      }

      return { start_date: start_date, end_date: end_date };
    },
    filterCompAccess(data) {
      this.$store.dispatch("Dashboard/SET_FILTER_COMPANY_ACCESS", {
        data
      });
      
      this.maxItem = data;
      
      let datePeriod;
      if(data.dates[0]) {
        datePeriod = this.getDatePeriod(data.dates);
        this.filterDate = [datePeriod.start_date, datePeriod.end_date];
      } else {
        datePeriod = {};
        this.filterDate = [];
      }
      this.$store.dispatch("Dashboard/GET_COMPANY_ACCESS", {
        start_date: (datePeriod && datePeriod.start_date) || '',
        end_date: (datePeriod && datePeriod.end_date) || '',
        sort: data.sort,
        region: data.region,
        filter: 1
      });
    },
    getBackgroundColor(numberOfItems) {
      const colors = [
        "#ff6961",
        "#ffb7ce",
        "#ca9bf7",
        "#89cff0",
        "#99c5c4",
        "#9adedb",
        "#aa9499",
        "#aaf0d1",
        "#ff694f",
        "#ff9899",
        "#b2fba5",
        "#b39eb5",
        "#bdb0d0",
        "#bee7a5",
        "#befd73",
        "#c1c6fc",
        "#c6a4a4",
        "#cb99c9",
        "#77DD77",
        "#836953"
      ];

      return colors.slice(0, numberOfItems);
    },
    fetchTotalCompany(startDate = null, endDate = null) {
      this.$store.dispatch("Dashboard/GET_TOTAL_COMPANY", {
        startDate: startDate,
        endDate: endDate
      });
    },
    filterTotalCompany(data) {
      
      this.$store.dispatch("Dashboard/SET_FILTER_TOTAL_COMPANY", {
        data
      });
      const datePeriod = this.getDatePeriod(data.dates);
      this.filterTotalCompanyDate = [
        datePeriod.start_date,
        datePeriod.end_date
      ];
      this.fetchTotalCompany(datePeriod.start_date, datePeriod.end_date);
    },
    resetFilterTotalCompany() {
      
      this.$store.dispatch("Dashboard/RESET_FILTER_TOTAL_COMPANY");
      this.filterTotalCompanyDate = [];
      this.fetchTotalCompany();
    },
    isLTMData() {
      return Object.keys(this.get_last_twelve_month).length > 0;
    }, 
    genLTMLabel() {
      var monthName = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
      var d = new Date();
      d.setDate(1);
      var label = [];
      for (var i=0; i<=11; i++) {
        d.setMonth(d.getMonth() - 1);
        label.push(monthName[d.getMonth()] + ' ' + d.getFullYear());
      }
      this.ltmLabel = label.reverse();
    }
  },
  watch: {
    getVersion() {
      this.resetFilterCompAccess();
      this.resetFilterTotalCompany();
    }
  },
  computed: {
    ...mapGetters("Layout", ["getVersion"]),
    ...mapGetters("Dashboard", ["get_comp_access", "get_filter_comp_access", "get_total_company", "get_filter_total_company", "get_last_twelve_month"]),
    regionsData() {
      const labels = this.get_total_company.map(item => item.region);
      const totalCompany = this.get_total_company.map(
        item => item.total_company
      );
      return {
        labels: labels,
        datasets: [
          {
            backgroundColor: this.getBackgroundColor(labels.length),
            data: totalCompany
          }
        ]
      };
    }
  },
  created() {
    this.genLTMLabel();
    this.resetFilterCompAccess();
    this.resetFilterTotalCompany();
    this.fetchTotalCompany();
    this.$store.dispatch("Dashboard/GET_COMPANY_ACCESS", {
      filter: 0
    });
    this.$store.dispatch("Dashboard/SET_LAST_TWELVE_MONTH");
  }
};
</script>
